import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { reducer as reduxFormReducer } from "redux-form";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import * as User from "./User";
import * as AccountHierarchy from "./AccountHierarchy";
import * as SnackbarStore from "./SnackbarStore";
import * as HierarchyModalStore from "./HierarchyModalStore";
import * as RollupModalStore from "./RollupModalStore";
import * as AccountStore from "./AccountStore";
import * as CompanyStore from "./CompanyStore";
import * as DepartmentStore from "./DepartmentStore";
import * as StrategyStore from "./StrategyStore";
import * as ScenarioStore from "./ScenarioStore";
import * as CustomAccountStore from "./CustomAccountStore";
import * as TransactionStore from "./TransactionStore";

export default function configureStore(history, initialState) {
  const reducers = {
    user: User.reducer,
    accountHierarchy: AccountHierarchy.reducer,
    snackbar: SnackbarStore.reducer,
    hierarchyModal: HierarchyModalStore.reducer,
    rollupModal: RollupModalStore.reducer,
    accounts: AccountStore.reducer,
    companies: CompanyStore.reducer,
    departments: DepartmentStore.reducer,
    strategies: StrategyStore.reducer,
    scenarios: ScenarioStore.reducer,
    customAccounts: CustomAccountStore.reducer,
    transactions: TransactionStore.reducer
  };

  const middleware = [thunk, routerMiddleware(history)];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === "development";
  if (
    isDevelopment &&
    typeof window !== "undefined" &&
    window.devToolsExtension
  ) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    router: connectRouter(history),
    form: reduxFormReducer,
    ...reducers
  });

  return createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(routerMiddleware(history), ...middleware),
      ...enhancers
    )
  );
}
